export const BLACK = '#222';



// WEBPACK FOOTER //
// ./src/style/index.js